/* eslint-disable no-console */
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import history from '~/services/history';
import api from '~/services/api';
import {
  signInSuccess,
  signFailure,
  revokeTokenRequest,
  revokeTokenSuccess,
  revokeTokenFailure,
} from './actions';

import * as actionsCareLines from '../careLines/actions';
import * as actionsInstituitions from '../instituitions/actions';

import * as types from './types';

export function* signIn({ payload }) {
  try {
    const { cpf, password } = payload;

    const response = yield call(api.post, 'autenticacao/autenticar', {
      cpf,
      password,
    });

    const {
      access_token,
      cnes,
      roles,
      primeiroLogin,
      institutionId,
    } = response.data;

    sessionStorage.setItem('institutionId', institutionId);

    toast.success('Logado com sucesso.', {
      autoClose: true,
    });

    api.defaults.headers.Authorization = `${access_token}`;

    const competence = yield call(api.get, 'configuracoes-sistema', {
      headers: {
        Authorization: access_token,
      },
    });

    const systemConfig = competence.data;

    const dataPayload = {
      token: access_token,
      cnes,
      roles,
      primeiroLogin,
      institutionId,
      systemConfig,
    };

    yield put(signInSuccess(dataPayload));

    const ROLE_ADMIN = roles.includes('ROLE_ADMIN');
    const ROLE_MANAGER = roles.includes('ROLE_MANAGER');

    if (!ROLE_ADMIN) {
      yield put(actionsCareLines.listarLcsRequest({ institutionId }));
      yield put(
        actionsInstituitions.getInstitutionRequest({ id: institutionId })
      );
    }

    if (!primeiroLogin) {
      if (!systemConfig?.usuarioAssinouTermo) {
        return history.push('/aceitar-termo');
      }
      history.push('/indicadores-gerais');
    } else {
      if (ROLE_ADMIN || ROLE_MANAGER) {
        history.push('/administrador/minha-conta?primeiro-login=true');
        return;
      }
      history.push('/minha-conta?primeiro-login=true');
    }
  } catch (err) {
    console.log('err :>> ', err);

    const { cause, fields } = err?.response?.data;

    if (cause === 'blocked') {
      document.getElementById('cpf').value = '';
      document.getElementById('password').value = '';
      Swal.fire({
        title: 'Bloqueado',
        text: `Seu usuário está bloqueado devido  à  cinco  falhas  sucessivas  de  login  e estará liberado  após 30  minutos. Para desbloqueio anterior a esse período, contatar administrador.`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
      yield put(signFailure());
      return;
    }

    if (cause === 'user_not_found') {
      document.getElementById('cpf').value = '';
      document.getElementById('password').value = '';
      Swal.fire({
        html: `<div style="padding:20px">
        ${err.response.data.error}</div>`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
      yield put(signFailure());
      return;
    }

    const attemptsValue = fields[0].value;

    const attempts =
      (attemptsValue === '1' && 4) ||
      (attemptsValue === '2' && 3) ||
      (attemptsValue === '3' && 2) ||
      (attemptsValue === '4' && 1);

    if (attempts <= 5) {
      document.getElementById('cpf').value = '';
      document.getElementById('password').value = '';
      Swal.fire({
        title: 'Dados incorretos',
        text: `Após 5 tentativas seu login será bloqueado por 30 minutos. ${
          attempts < 2 ? 'Resta' : 'Restam'
        } ${attempts} ${attempts < 2 ? 'tentativa' : 'tentativas'}.`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
      yield put(signFailure());
    }
  }
}

export function* revokeToken() {
  try {
    yield call(api.post, 'user-blocked-token');
    yield put(revokeTokenSuccess());
  } catch {
    yield put(revokeTokenFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { access_token } = payload.auth;

  if (access_token) {
    api.defaults.headers.Authorization = `${access_token}`;
  }
}

export function* signOut() {
  yield put(revokeTokenRequest());
  sessionStorage.removeItem('persist:sihosp');
  sessionStorage.removeItem('cpf');
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest(types.SIGN_IN_REQUEST, signIn),
  takeLatest(types.SIGN_OUT, signOut),
  takeLatest(types.REVOKE_TOKEN_REQUEST, revokeToken),
]);
